/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    string,
} from 'prop-types';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { determineChatlink } from '../Global_chat_helpers';
import { getCurrentBrandId, getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getOperatingSystem } from '../../../../state/ducks/App/ducks/Config/Config-Helpers';

const triggerPopChatEvent = (
    payload = {},
    operatingSystem = '',
    currentBrand = '',
    featureFlags = {},
    customerData = {},
) => {
    const isAndroid = operatingSystem === 'android';
    const isIOS = operatingSystem === 'ios';
    const isMobile = isAndroid || isIOS;
    const isBrowser = typeof window !== 'undefined';
    const ffIsConvUiGlobalEnabled = featureFlags?.['is-conv-ui-enabled'];
    let conversationalUIEnabled = false;
    if (!isMobile) {
        // if desktop (not mobile), read from the global flag
        conversationalUIEnabled = ffIsConvUiGlobalEnabled;
    } else {
        // if NOT desktop, then read from the mobile flag (array shape)
        conversationalUIEnabled = (ffIsConvUiGlobalEnabled && featureFlags?.['is-flora-chat-for-current-mobile-device-enabled']?.length && featureFlags?.['is-flora-chat-for-current-mobile-device-enabled']?.includes(operatingSystem?.toLowerCase()));
    }

    if (!isBrowser) return;

    const dispatchDesktopChatEvent = () => {
        const desktopChatEvent = new CustomEvent('popOpenChat', { detail: payload });
        window.dispatchEvent(desktopChatEvent);
    };

    if (isMobile) {
        // exception case for mobile as persistPage is called in mobile aswell.
        if (payload?.didSetPersistData) return;
        if (payload?.loadMoreButtonClick) return;
        if (isAndroid) return;
        if (conversationalUIEnabled) {
            dispatchDesktopChatEvent();
        } else {
            if (payload?.didSetPersistData) return;
            const href = determineChatlink(operatingSystem, currentBrand, featureFlags, customerData);
            if (href) {
                window.location.href = href;
            }
        }
    } else {
        if (payload?.loadMoreButtonClick) return;
        const shouldDispatchDesktopChatEvent = !conversationalUIEnabled;
        if (shouldDispatchDesktopChatEvent) {
            dispatchDesktopChatEvent();
        } else {
            dispatchDesktopChatEvent();
        }
    }
};

export const RenderChatAsLink = ({
    value,
}) => {
    const operatingSystem = getOperatingSystem().toLowerCase();
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const customerData = useSelector((state) => state?.member);
    const featureFlags = useSelector((state) => getFeatureFlags(state));
    const chatRegex = /(chatting|chat)/gi;
    const parts = value?.split(chatRegex);
    const renderPart = (part, index) => {
        const linkStyle = operatingSystem !== 'android' ? { textDecoration: 'underline', cursor: 'pointer' } : null;
        if (part?.toLowerCase() === 'chat' || part?.toLowerCase() === 'chatting') {
            return (
                <span
                    key={index}
                    onClick={() => {
                        triggerPopChatEvent({}, operatingSystem, currentBrand, featureFlags, customerData);
                    }}
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex="0"
                    alt="chat"
                    style={linkStyle}
                >
                    {part}
                </span>
            );
        }
        // removing extra br tag
        const cleanedPart = part?.replace(/<\/br>/g, '');
        return <React.Fragment key={index}>{ReactHtmlParser(cleanedPart)}</React.Fragment>;
    };
    return (
        <span>
            {parts?.map((part) => (
                <>
                    {renderPart(part)}
                </>
            ))}
        </span>
    );
};

RenderChatAsLink.propTypes = {
    value: string.isRequired,
};

export default triggerPopChatEvent;
